import { ActionHandlerRegistry } from "./actionHandlerRegistry";
import { FollowupQuestionsAction } from "./FollowupQuestionsAction";

const actionHandlerRegistry = new ActionHandlerRegistry();
actionHandlerRegistry.register("followup_questions", FollowupQuestionsAction);

export { actionHandlerRegistry };
export { isClientAction } from "./types";
export type { ClientAction } from "./types";
